import {StringPatternSchema} from 'favorlogic-utils';

import {validationRegularExpressions} from 'utils/DairyValidator';

export const BarcodeSchema = StringPatternSchema<BarcodeSchema>(validationRegularExpressions.barcode);

export type BarcodeSchema = string;
